import { Box, Typography } from "@mui/material";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { useFormContext } from "../../contexts/FormContext";

export const AddressDisplayWithIcon = () => {
  const { formValues } = useFormContext();

  // combile all in on string wiht commas and also handle the case if empty
  const primaryAddress =
    formValues?.address1 &&
    formValues.address1 !== "No address collected" &&
    formValues.address1.trim();

  const addressParts = [
    primaryAddress,
    formValues?.address2?.trim() ?? "",
    formValues?.city?.trim() ?? "",
    formValues?.state?.trim() ?? "",
    formValues?.zipcode?.trim() ?? "",
  ].filter(Boolean);

  const fullAddress = addressParts.join(", ");

  return (
    <Box
      sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
      className="address-display-with-icon"
    >
      {fullAddress && (
        <>
          <HomeOutlinedIcon />
          <Typography
            variant="h3"
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "0",
              color: "#000",
            }}
          >
            {fullAddress}
          </Typography>
        </>
      )}
    </Box>
  );
};
